/* eslint-disable no-tabs */

import { View } from 'components/View'
import { MUSCLE } from '@gymaholic/packages'
import PropTypes from 'prop-types'
import React from 'react'

const MIN_USAGE = 0.05
const MIN_OPACITY = 0.5
const OPACITY_RATIO_PER_UNIT = 0.5

const ForearmsSvg = ({ fillColor }) => {
  return (
    <>
      <path
        className='forearms'
        fill={fillColor}
        d='M219.5,99.5c1.5-3.8,2.8-7.2,4.5-11.2C220,90.4,218.2,95.4,219.5,99.5z'
      />
      <path
        className='forearms'
        fill={fillColor}
        d='M307.5,98.9c1.1-4.4-0.4-8.4-4.1-9.9C304.9,92.4,306.2,95.8,307.5,98.9z'
      />
      <path
        className='forearms'
        fill={fillColor}
        d='M317.8,125.3c0.5-6.1-4.9-27.2-7.7-31C310.7,104.9,312.3,115.5,317.8,125.3z'
      />
      <path
        className='forearms'
        fill={fillColor}
        d='M216.7,95.2c-3.8,9.8-6.9,19.8-7.8,31.1C214.6,116.2,216.7,105.9,216.7,95.2z'
      />
      <path
        className='forearms'
        fill={fillColor}
        d='M320.7,126.4c1.8-0.7,4.2-0.5,3.3-3.2c-2.1-7.3-4.4-14.7-6.8-22c-1.2-3.7-2.9-7.2-4.5-10.7
	c-0.2,0.1-0.5,0.2-0.7,0.3C316.8,102.1,319.6,113.8,320.7,126.4z'
      />
      <path
        className='forearms'
        fill={fillColor}
        d='M214.5,92.2c-0.3-0.1-0.5-0.2-0.8-0.3c-1.2,3-2.6,6-3.7,9c-2.2,7.1-4.3,14.3-6.5,21.4c-0.9,2.8-0.1,4,3.1,3.7
	C207.6,114.3,210.5,103,214.5,92.2L214.5,92.2z'
      />
      <path
        className='forearms'
        fill={fillColor}
        d='M224,94.7c-0.3-0.2-0.5-0.4-0.8-0.6c-2.9,8.6-5.9,17.2-8.8,25.9c6.6-7.9,11.5-16.6,14.5-26.3
	C227,94,225.5,94.4,224,94.7L224,94.7z'
      />
      <path
        className='forearms'
        fill={fillColor}
        d='M298.6,93.7c1.1,6.4,9.4,21.9,13.9,25.8c-1.2-4.3-2.3-8.5-3.8-12.7c-1.5-4.3-3.2-8.4-5-12.6
	c-0.2,0.2-0.4,0.4-0.6,0.6C301.6,94.4,300,94,298.6,93.7z'
      />
      <path
        className='forearms'
        fill={fillColor}
        d='M46.2,84.8c-3.5,3.3-5.8,7.8-7.6,15.5c-1.9,8.5-3.7,17-9.2,24.3c0.7-0.2,1.3-0.5,1.6-1
	c4-6.2,7.7-12.5,11.7-18.6C46.8,98.8,48.2,92.3,46.2,84.8z'
      />
      <path
        className='forearms'
        fill={fillColor}
        d='M152.9,124.8c0.2-0.1,0.4-0.3,0.6-0.4c-4.8-6.2-6.9-13.4-8.6-20.8c-1.1-4.7-2.7-9.2-4.5-13.7
	c-0.7-1.8-2.2-3.4-3.7-5.4c-2.2,8.1-0.5,14.8,3.7,21.2c4,5.9,7.5,12,11.3,17.8C152,124.1,152.5,124.4,152.9,124.8L152.9,124.8z'
      />
      <path
        className='forearms'
        fill={fillColor}
        d='M50.6,101c-9.6,5.4-11.4,16.1-17,24.1C39.2,117.1,44.9,109,50.6,101z'
      />
      <path
        className='forearms'
        fill={fillColor}
        d='M149.3,124.9c-5.7-7.8-7.3-18.5-16.7-23.6C138.1,109.2,143.7,117.2,149.3,124.9z'
      />
      <path
        className='forearms'
        fill={fillColor}
        d='M57.6,90.7c-5,1.9-9.9,6.7-10.5,10c2.5-1.3,5.1-2.7,7.7-4.1C57.5,95.3,58.2,93.9,57.6,90.7z'
      />
      <path
        className='forearms'
        fill={fillColor}
        d='M136.4,101c-2.6-5.1-6.5-8-11.3-10.6c-0.3,2.5-0.1,4.6,1.8,5.7C129.9,97.7,132.9,99.3,136.4,101z'
      />
      <path
        className='forearms'
        fill={fillColor}
        d='M140.4,121.7c-4.3-7.8-8.4-15.7-12.7-23.5C129.5,107.4,135.2,114.3,140.4,121.7z'
      />
      <path
        className='forearms'
        fill={fillColor}
        d='M55.5,98.8c-0.2-0.1-0.4-0.2-0.6-0.3c-4,7.4-7.9,14.8-11.9,22.3C48,113.8,53.3,107.2,55.5,98.8z'
      />
      <path
        className='forearms'
        fill={fillColor}
        d='M145.9,127.4c0.2-0.1,0.4-0.2,0.5-0.3c-3.5-7.6-7.4-15.1-13.3-21.3C137.4,112.9,141.7,120.1,145.9,127.4z'
      />
      <path
        className='forearms'
        fill={fillColor}
        d='M36,126.8c0.3,0.2,0.6,0.3,0.9,0.5c4.3-7.2,8.4-14.3,12.7-21.5c-0.4-0.2-0.7-0.4-1.1-0.6
	C44.4,112.4,40.3,119.6,36,126.8z'
      />
    </>
  )
}

const OthersSvg = () => {
  return (
    <>
      <path
        className='others'
        d='M335.5,129.5c-0.5,0.5-1.1,0.8-1.4,1.3c-0.2,0.4-0.2,1.2,0,1.4c1.3,1,2.7,2,4.2,2.8c0.3,0.2,1.1,0,1.4-0.3
	s0.3-1.2,0.1-1.4C338.6,131.9,337.2,130.8,335.5,129.5L335.5,129.5z'
      />
      <path
        className='others'
        d='M191.8,129.5c-1.3,1-2.7,1.8-4.1,2.9c-0.4,0.4-0.3,1.3-0.4,2c0.7,0.1,1.5,0.4,2.1,0.1c0.9-0.3,1.5-1.2,2.4-1.6
	C194,131.9,193.7,130.9,191.8,129.5z'
      />
      <path
        className='others'
        d='M194.7,138.3c-2.4-0.3-5.7,5.1-5,8.2C191.8,144.2,193,141.2,194.7,138.3z'
      />
      <path
        className='others'
        d='M324.6,139.9c-0.2,0.1-0.3,0.3-0.5,0.4c0.7,2.6,1.3,5.3,2.1,7.8c0.1,0.4,0.9,0.6,1.3,0.9
	c0.2-0.4,0.6-0.9,0.5-1.3c-0.6-2.3-1.2-4.6-2-6.9C325.9,140.4,325.1,140.2,324.6,139.9z'
      />
      <path
        className='others'
        d='M337.9,146.5c0.2-0.2,0.5-0.4,0.7-0.6c-1.3-2.5-2.5-5.1-4-7.6c-0.2-0.3-0.9-0.3-1.3-0.4c-0.1,0.5-0.3,1-0.2,1.4
	c1,2.1,2.1,4.3,3.3,6.3C336.8,146.1,337.5,146.2,337.9,146.5L337.9,146.5z'
      />
      <path
        className='others'
        d='M198.9,149.2c1-0.1,1.5,0,1.5-0.1c0.9-2.7,1.7-5.5,2.5-8.3c0.1-0.2-0.4-0.7-0.6-0.7c-0.4,0-1,0.2-1,0.4
	C200.5,143.2,199.8,146,198.9,149.2L198.9,149.2z'
      />
      <path
        className='others'
        d='M331.7,133.5c0.3-2.6-2.6-7-4.4-7.4c-0.3-0.1-0.8,0.1-0.9,0.3c-0.1,0.3-0.2,0.9,0,1.2
	C328,129.4,329.7,131.2,331.7,133.5z'
      />
      <path
        className='others'
        d='M201.4,126.9c-0.1-0.2-0.2-0.4-0.3-0.6c-0.6,0.1-1.4,0.1-1.7,0.4c-1.6,1.8-4.9,2.7-3.7,6.7
	C197.7,131,199.6,129,201.4,126.9L201.4,126.9z'
      />
      <path
        className='others'
        d='M249.5,291c0.6-2.8-2.2-5.8-5.5-5.7C245.8,287.1,247.5,288.9,249.5,291z'
      />
      <path
        className='others'
        d='M277.5,290.4c2.9-1.3,4.9-3.5,5.1-5.8C279.2,286,277.2,288.1,277.5,290.4z'
      />
      <path
        className='others'
        d='M205.9,139.1c-0.6,3-1,5.5-1.5,8c0.2,0,0.5,0.1,0.7,0.1C206.8,144.9,207.4,140.7,205.9,139.1z'
      />
      <path
        className='others'
        d='M321.6,147.5c0.3-0.1,0.6-0.1,0.9-0.2c0.3-2.7-0.7-6.7-2.7-7.9C320.5,142.4,321.1,144.9,321.6,147.5
	L321.6,147.5z'
      />
      <path
        className='others'
        d='M271.7,287.6c0.3-0.2,0.7-0.3,1-0.5c-0.8-1.7-1.5-3.4-2.3-5.2c-0.4,0.2-0.7,0.3-1.1,0.5
	C267.8,285.1,271.5,285.6,271.7,287.6z'
      />
      <path
        className='others'
        d='M254.7,287.1c0.2,0.1,0.5,0.2,0.7,0.3c3.4-3.9,3.4-3.9,1.4-5.4C256,283.8,255.3,285.4,254.7,287.1z'
      />
      <path
        className='others'
        d='M198.2,133.6l0.7,2l3.3-5.9L198.2,133.6z'
      />
      <path
        className='others'
        d='M201.4,135.9h1.6l0.9-5.5L201.4,135.9z'
      />
      <path
        className='others'
        d='M205.1,135.9h1.6l0.5-6L205.1,135.9z'
      />
      <path
        className='others'
        d='M320.1,130.4l0.7,5.5h1.5L320.1,130.4z'
      />
      <path
        className='others'
        d='M323.6,130.3l1.1,5.6h1.4v-1.3L323.6,130.3z'
      />
      <path
        className='others'
        d='M326.1,129.2l2.4,6.4l0.9-1.5L326.1,129.2z'
      />
      <path
        className='others'
        d='M252.8,290.2c-0.7,0-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3s1.3,0.6,1.3,1.3S253.5,290.2,252.8,290.2z'
      />
      <path
        className='others'
        d='M274.8,290.2c-0.7,0-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3s1.3,0.6,1.3,1.3S275.5,290.2,274.8,290.2z'
      />
      <path
        className='others'
        d='M328.9,139.3c-0.2,0.3-0.4,0.6-0.6,0.8c0.9,2.5,1.8,5.2,2.9,7.7c0.2,0.6,1,1,1.5,1.5c0.1-0.8,0.5-1.6,0.3-2.3
	c-0.6-2.1-1.4-4.3-2.3-6.3C330.5,140.2,329.6,139.9,328.9,139.3z'
      />
      <path
        className='others'
        d='M193.9,149.1c0.4,0.1,0.7,0.3,1.1,0.4c2.1-2.7,2.7-6.1,3.9-9.2c0-0.1-0.6-0.7-0.9-0.7c-0.4,0.1-1,0.4-1.2,0.8
	c-0.7,1.8-1.4,3.7-2,5.5C194.3,146.7,194.1,148,193.9,149.1z'
      />
      <path
        className='others'
        d='M32,127.7c-1.9,1.6-3.4,3.2-5.3,4.6c-1.7,1.2-3.8,2.1-5.5,3.3c-2.1,1.5-2.1,2.9,0.3,3.9c2.6,1,5.5,1.5,8.3,1.8
	c3,0.4,3.7-0.4,2.7-3.4c-0.2-0.7-0.5-1.4-0.5-2C32,133,32,130.4,32,127.7L32,127.7z'
      />
      <path
        className='others'
        d='M151.5,128.8c-0.5,2.9-1,6.8-1.6,10.5c-0.3,1.8,1,2,2.1,1.9c2.7-0.3,5.5-0.7,8.1-1.4c1.1-0.3,2-1.5,3-2.2
	c-0.9-0.9-1.6-2-2.6-2.7C157.4,132.5,154.1,130.5,151.5,128.8z'
      />
      <path
        className='others'
        d='M93.8,196.6c0,3-0.5,5.9,0.1,8.3c1.6,6,3.8,11.8,5.7,17.6c1.4-4.8,0.4-9.1-1.6-13.5
	C96.1,205.3,95.2,201.2,93.8,196.6L93.8,196.6z'
      />
      <path
        className='others'
        d='M88.9,197.8c-1.5,4.4-2.9,9-4.9,13.4c-1.7,4-1.7,7.7-0.8,11.4c0.8-2.4,1.2-5.4,2.6-7.8
	C89.2,209.3,89.5,203.5,88.9,197.8L88.9,197.8z'
      />
      <path
        className='others'
        d='M111.6,193.7c-0.2,0-0.3-0.1-0.5-0.1c-1.7,5.3-3.4,10.6-5.3,16.3c1.7-1.2,2.9-2,4.1-2.9
	c0.7-0.6,1.5-1.4,1.6-2.1C111.7,201.2,111.6,197.4,111.6,193.7L111.6,193.7z'
      />
      <path
        className='others'
        d='M76.9,209.6c-1.5-4.9-2.9-9.4-4.4-13.9c-0.2-0.6-0.5-1.1-1-2.2v12.7C73.3,207.3,74.8,208.4,76.9,209.6z'
      />
      <path
        className='others'
        d='M103.5,198.4c-2.2,0-3.8,1.2-3.8,2.8s1.8,3.8,3.5,3.9c1.4,0.1,3.5-2.2,3.5-3.9
	C106.7,199.1,104.9,198.7,103.5,198.4z'
      />
      <path
        className='others'
        d='M76.1,202.4c0.8,0.7,1.9,2.1,3.3,2.6s3.9-2.2,3.7-3.9c-0.2-2.1-1.8-2.8-3.5-2.7
	C77.8,198.4,76.3,199.2,76.1,202.4L76.1,202.4z'
      />
      <path
        className='others'
        d='M19.2,130.8c5.8,1.4,9.9-0.3,11.1-4.4C26,125.7,22.6,127.5,19.2,130.8z'
      />
      <path
        className='others'
        d='M152.5,126.4c1.8,4.4,6.4,6.1,11,4.2C160.4,127.5,157,125.8,152.5,126.4z'
      />
      <path
        className='others'
        d='M83.2,284.4c0.2,0.2,0.5,0.4,0.7,0.7c0.6-0.6,1.7-1,1.8-1.7c0.4-2.6,0.6-5.3,0.8-7.9c0-0.5-0.6-1-1-1.5
	c-0.4,0.4-1.1,0.8-1.2,1.3C83.9,278.3,83.6,281.4,83.2,284.4z'
      />
      <path
        className='others'
        d='M98.9,285.1c0.2-0.2,0.5-0.5,0.7-0.7c-0.3-3-0.6-6-1-9c-0.1-0.5-0.8-0.9-1.2-1.4c-0.4,0.6-1.1,1.2-1,1.7
	c0.2,2.5,0.5,5.2,0.9,7.6C97.3,284,98.3,284.5,98.9,285.1z'
      />
      <path
        className='others'
        d='M159.1,141.5c-0.2,0.3-0.4,0.6-0.6,0.9c1.1,2.5,2.1,5.1,3.3,7.5c0.3,0.6,1.1,0.9,1.6,1.4
	c0.1-0.8,0.4-1.6,0.2-2.3c-0.8-2.1-1.8-4.3-2.8-6.3C160.5,142.2,159.6,142,159.1,141.5L159.1,141.5z'
      />
      <path
        className='others'
        d='M23.4,141.3c-0.3,0-0.5,0.1-0.8,0.1c-1.2,2.6-2.4,5.3-3.5,8c-0.2,0.5,0.2,1.2,0.3,1.8c0.5-0.4,1.2-0.6,1.5-1.1
	c1.1-2.2,2.1-4.5,3-6.8C24.1,142.9,23.6,142.1,23.4,141.3z'
      />
      <path
        className='others'
        d='M163.4,133.9c1.5,1,2.9,1.9,4.5,2.6c0.5,0.2,1.2-0.2,1.9-0.3c-0.1-0.6-0.1-1.5-0.4-1.8
	c-0.7-0.7-1.7-1.2-2.6-1.9C165,131.2,164,131.5,163.4,133.9z'
      />
      <path
        className='others'
        d='M20,140.8c-0.2-0.3-0.4-0.7-0.6-0.8c-0.4-0.1-1,0-1.2,0.2c-1.4,2.2-2.7,4.6-4.1,6.9c-0.1,0.2,0.1,0.8,0.4,1.1
	c0.1,0.1,0.8,0.1,0.9-0.1C16.9,145.7,18.5,143.2,20,140.8L20,140.8z'
      />
      <path
        className='others'
        d='M157.4,151.7c0.4-0.1,0.7-0.2,1.1-0.2c0.4-3-1.5-5.7-2.3-8.5c-0.1-0.3-1-0.4-2.1-0.7
	C155.2,145.7,156.3,148.7,157.4,151.7z'
      />
      <path
        className='others'
        d='M167.7,148.6c0.4-0.2,0.9-0.5,1.3-0.7c-1.1-2.9-2.8-5.5-4.7-8c-0.1-0.2-1,0.3-1.7,0.5
	C164.5,143.4,166.1,146,167.7,148.6L167.7,148.6z'
      />
      <path
        className='others'
        d='M24.4,151.6c0.3,0.1,0.7,0.1,1,0.2c0.9-2.8,1.9-5.7,2.8-8.5c0-0.2-0.6-0.8-0.8-0.7c-0.4,0.2-0.9,0.5-1.1,0.9
	c-0.8,2.1-1.5,4.2-2.1,6.3C24.1,150.3,24.3,151,24.4,151.6z'
      />
      <path
        className='others'
        d='M148.3,136.8c0.4-0.1,0.8-0.1,1.3-0.2c-0.1-2.3-0.2-4.7-0.5-7c0-0.4-0.7-0.8-1-1.2c-0.3,0.4-1,0.9-1,1.3
	C147.5,132,147.9,134.5,148.3,136.8L148.3,136.8z'
      />
      <path
        className='others'
        d='M102.7,284.9c-0.6-3.5-0.4-7-2.4-9.7c0,2.9,0.3,5.9,0.8,8.7C101.1,284.3,102.1,284.6,102.7,284.9L102.7,284.9z'
      />
      <path
        className='others'
        d='M33.7,128c-0.2,3.2-0.3,5.9-0.4,8.5C36.3,132.7,36.5,129.8,33.7,128z'
      />
      <path
        className='others'
        d='M79.6,284.8c2.2-0.4,3.5-5.5,3-9.6c-0.2-0.1-0.5-0.1-0.7-0.2C81.2,278,80.4,281.3,79.6,284.8L79.6,284.8z'
      />
      <path
        className='others'
        d='M89.1,275c-0.3,0-0.6,0-0.9,0c-0.3,2.8-0.6,5.6-0.8,8.4c0,0.4,0.6,0.8,1,1.2c0.2-0.4,0.7-0.8,0.7-1.2
	C89.1,280.6,89.1,277.9,89.1,275z'
      />
      <path
        className='others'
        d='M94.7,275c-0.3,0-0.7,0-1,0v8.6c0,0.3,0.6,0.7,1,0.9c0.1,0.1,0.8-0.5,0.8-0.7C95.2,281,95,278,94.7,275z'
      />
      <path
        className='others'
        d='M29.3,149.8c0.4,0.1,0.8,0.2,1.3,0.3c0.7-2.2,1.4-4.4,2-6.6c0.1-0.2-0.3-0.8-0.4-0.8c-0.4,0-0.9,0.2-1,0.4
	C30.5,145.2,29.9,147.5,29.3,149.8L29.3,149.8z'
      />
      <path
        className='others'
        d='M152.3,150.1c0.3-0.1,0.5-0.1,0.8-0.2c0.5-2.4-0.9-6.5-3.1-7.6C150.8,145.2,151.6,147.6,152.3,150.1z'
      />
      <path
        className='others'
        d='M80.5,212.6c0.8-2.5,1.3-4.4,1.8-6.2c-1.3,0.4-2.3,0.7-3.5,1C79.4,209,79.8,210.4,80.5,212.6z'
      />
      <path
        className='others'
        d='M102.3,212.6c0.6-1.9,1.1-3.5,1.6-5.3c-1.2-0.3-2.3-0.6-3.4-0.9C101.1,208.5,101.7,210.4,102.3,212.6
	L102.3,212.6z'
      />
      <path
        className='others'
        d='M102.7,277c1.2,6.2,2.2,7.7,4.2,6.7C105.6,281.5,104.1,279.3,102.7,277z'
      />
      <path
        className='others'
        d='M80.1,278.4c-0.2-0.1-0.4-0.2-0.6-0.3c-1.2,1.9-2.5,4-3.8,5.9c0.2,0.2,0.5,0.3,0.7,0.5
	C79.4,283.5,78.8,280.4,80.1,278.4L80.1,278.4z'
      />
      <path
        className='others'
        d='M100.9,290.1c-0.4,0.2-0.8,0.1-1-0.3l-0.7-1.2c-0.2-0.4-0.1-0.8,0.3-1s0.8-0.1,1,0.3l0.7,1.2
	C101.4,289.4,101.3,289.9,100.9,290.1z'
      />
      <path
        className='others'
        d='M104.3,290.1c-0.4,0.2-0.8,0.1-1-0.3l-0.7-1.2c-0.2-0.4-0.1-0.8,0.3-1s0.8-0.1,1,0.3l0.7,1.2
	C104.8,289.4,104.7,289.9,104.3,290.1z'
      />
      <path
        className='others'
        d='M106.8,289.2c-0.4,0.2-0.8,0.1-1-0.3l-0.7-1.2c-0.2-0.4-0.1-0.8,0.3-1s0.8-0.1,1,0.3l0.7,1.2
	C107.3,288.6,107.2,289.1,106.8,289.2z'
      />
      <path
        className='others'
        d='M109.1,288.6c-0.4,0.2-0.8,0.1-1-0.3l-0.7-1.2c-0.2-0.4-0.1-0.8,0.3-1s0.8-0.1,1,0.3l0.7,1.2
	C109.5,287.9,109.4,288.4,109.1,288.6z'
      />
      <path
        className='others'
        d='M81.2,290.6c0.4,0.2,0.8,0.1,1-0.3l0.7-1.2c0.2-0.4,0.1-0.8-0.3-1s-0.8-0.1-1,0.3l-0.7,1.2
	C80.8,289.9,80.9,290.4,81.2,290.6z'
      />
      <path
        className='others'
        d='M78.4,290.1c0.4,0.2,0.8,0.1,1-0.3l0.7-1.2c0.2-0.4,0.1-0.8-0.3-1s-0.8-0.1-1,0.3l-0.7,1.2
	C77.9,289.4,78.1,289.7,78.4,290.1z'
      />
      <path
        className='others'
        d='M75.9,289.2c0.4,0.2,0.8,0.1,1-0.3l0.7-1.2c0.2-0.4,0.1-0.8-0.3-1s-0.8-0.1-1,0.3l-0.7,1.2
	C75.4,288.5,75.5,289,75.9,289.2z'
      />
      <path
        className='others'
        d='M73.7,288.5c0.4,0.2,0.8,0.1,1-0.3l0.7-1.2c0.2-0.4,0.1-0.8-0.3-1s-0.8-0.1-1,0.3l-0.7,1.2
	C73.2,287.7,73.3,288.2,73.7,288.5z'
      />
    </>
  )
}

const AbsSvg = ({ fillColor }) => {
  return (
    <>
      <path
        className='abs'
        fill={fillColor}
        d='M89.5,117.8c0.1-2.7,0.1-5.6,0.1-8.3c0-5.7-2.5-8.2-8.2-8.4c-1.7-0.1-2.7,0.4-2.5,2.4c0.2,2.4,0,5.1,0.6,7.4
		c1.4,5.9,3,11.7,4.9,17.3c0.3,1,2.1,1.5,3.2,2.2c0.6-1.1,1.6-2.1,1.7-3.3C89.6,124.2,89.5,121.1,89.5,117.8L89.5,117.8z'
      />
      <path
        className='abs'
        fill={fillColor}
        d='M92.2,117.8c0,3.3-0.1,6.4,0.2,9.3c0.1,1.2,1.1,2.2,1.7,3.3c1.1-0.7,2.9-1.2,3.2-2.2
		c1.9-5.6,3.5-11.4,4.9-17.3c0.6-2.3,0.4-5,0.6-7.4c0.2-2-0.8-2.5-2.5-2.4c-5.7,0.2-8.2,2.7-8.2,8.4
		C92.1,112.2,92.1,115.1,92.2,117.8L92.2,117.8z'
      />
      <path
        className='abs'
        fill={fillColor}
        d='M89.6,95.4c0-5.9-1-6.8-6.7-6.3c-3.8,0.4-6.5,5.1-4.7,8.5c0.3,0.6,1.3,0.9,2.1,1.1c1.4,0.3,2.8,0.2,4.3,0.5
		C89.6,100.6,89.6,100.8,89.6,95.4L89.6,95.4z'
      />
      <path
        className='abs'
        fill={fillColor}
        d='M92.1,95.4c0,5.4,0,5.2,5,3.8c1.5-0.3,2.9-0.2,4.3-0.5c0.8-0.2,1.8-0.5,2.1-1.1c1.8-3.4-0.9-8.1-4.7-8.5
		C93.1,88.6,92.1,89.5,92.1,95.4L92.1,95.4z'
      />
      <path
        className='abs'
        fill={fillColor}
        d='M89.6,86.8c0-1.7,0-3.4,0-5.1c0-4.5-1.7-5.7-5.9-4.1c-1.3,0.5-2.5,1.3-3.7,2.2c-2.5,2.3-3,6-1.5,7.8
		C82.3,87.3,85.7,87.1,89.6,86.8L89.6,86.8z'
      />
      <path
        className='abs'
        fill={fillColor}
        d='M104.5,87.7c1-2.4,0.6-4.9-1.2-7.1c-2-2.4-4.8-3.8-8-3.3c-0.7,0.1-1.8,0.9-1.9,1.4c-0.2,2.7-0.1,5.6-0.1,8.1
		C97.2,87.1,100.7,87.3,104.5,87.7z'
      />
      <path
        className='abs'
        fill={fillColor}
        d='M78.2,77.7c3.5-1.1,6.8-2,10-3.1c0.6-0.2,1.2-1,1.3-1.7c0.2-1.2,0.2-2.5,0-3.8c-0.1-0.6-0.8-1.4-1.4-1.5
		c-3.3-0.5-6.2,0.9-8.4,3.1C77.7,72.6,77.3,75.1,78.2,77.7L78.2,77.7z'
      />
      <path
        className='abs'
        fill={fillColor}
        d='M104.5,77.7c1.3-4.7-1-8.4-6.2-9.8c-4.2-1.1-5.2-0.4-5,3.9c0,1,0.5,2.5,1.2,2.8
		C97.7,75.6,101.1,76.6,104.5,77.7z'
      />
    </>
  )
}

const NeckSvg = ({ fillColor }) => {
  return (
    <>
      <path
        className='neck'
        fill={fillColor}
        d='M92.7,40.5c3.9-6.3,8.1-12.4,8.1-20.5C96,26.2,92.1,32.4,92.7,40.5z'
      />
      <path
        className='neck'
        fill={fillColor}
        d='M82.1,20.2c-0.1,8.2,4.3,14.2,7.8,20.6C91.5,35.6,88.3,27.9,82.1,20.2z'
      />
    </>
  )
}

const BicepsSvg = ({ fillColor }) => {
  return (
    <>
      <path
        className='biceps'
        fill={fillColor}
        d='M60.2,58.3c-1.7,0.7-3.3,1.3-5,2c-0.6,0.3-1.3,0.7-1.5,1.3c-1.5,5.9-3.1,11.9-4.3,17.8c-0.3,1.4,0.8,4,2,4.7
		c2,1.2,3.8-0.5,5.2-2.1c0.3-0.3,0.5-0.7,0.7-1.1c3.3-4.7,4.6-10.1,5.7-15.7C63.7,62.2,63.8,59.5,60.2,58.3L60.2,58.3z'
      />
      <path
        className='biceps'
        fill={fillColor}
        d='M122.1,57.8c-1,1.5-2.8,2.9-2.6,4.1c0.6,5.9,1.6,11.7,4.7,16.8c1.1,1.8,2.4,3.7,4,5c2.1,1.8,4.6,0.8,5.1-2
		c0.2-1.1,0.4-2.3,0.2-3.4c-0.7-4-1.7-7.8-2.5-11.8c-0.8-3.8-2.2-6.9-6.6-7.5C123.6,58.9,123.1,58.4,122.1,57.8L122.1,57.8z'
      />
      <path
        className='biceps'
        fill={fillColor}
        d='M51.8,61.9c-4.9,3.9-6.3,22.2-1.8,26.8C46.4,79.3,48.2,70.6,51.8,61.9z'
      />
      <path
        className='biceps'
        fill={fillColor}
        d='M131.1,62c3.5,8.6,5.4,17.2,1.7,26.9C137.2,84.1,135.8,66,131.1,62z'
      />
      <path
        className='biceps'
        fill={fillColor}
        d='M49.7,90.8c4.7-1.7,7.7-4.9,9.2-9.3c0.3,0.3,0.6,0.7,0.9,1C56.5,85.4,53.1,88.2,49.7,90.8z'
      />
      <path
        className='biceps'
        fill={fillColor}
        d='M132.7,91.3l0.8-0.8c-3.7-2.8-7.4-5.7-11.1-8.5l1-1C125.1,85.7,128.2,89.2,132.7,91.3z'
      />
    </>
  )
}

const AbductorsSvg = ({ fillColor }) => {
  return (
    <>
      <path
        className='abductors'
        fill={fillColor}
        d='M118.4,132.4c0-5.5-0.3-11-1.9-16.2c-0.3,0-0.6,0.1-0.9,0.1C116.5,121.8,117.4,127.1,118.4,132.4L118.4,132.4z'
      />
      <path
        className='abductors'
        fill={fillColor}
        d='M64.1,131.3c0.2,0,0.4,0,0.6,0.1c0.8-5,1.7-9.8,2.5-14.8c-0.4-0.1-0.8-0.1-1.2-0.2
		C65.3,121.3,64.7,126.2,64.1,131.3L64.1,131.3z'
      />
    </>
  )
}

const LatsSvg = ({ fillColor }) => {
  return (
    <>
      <path
        className='lats'
        fill={fillColor}
        d='M255.7,113.1c0.2-1.1,0.4-1.5,0.3-2c-1.5-10.9-3.5-21.6-1-32.6c-0.2-2.9-0.2-6.2-2.2-8.6
		c-3.4-4.3-7.2-7.7-12.5-8.5c-2.5-0.4-5.1-0.9-8-1.4c0.4,1.8,0.6,2.8,0.9,3.9c3.6,11.4,7.1,22.7,10.9,33.9c0.6,1.8,1.7,3.4,2.8,4.9
		c2.1,2.8,4.5,5.5,6.7,8.2C254.2,111.6,254.8,112.2,255.7,113.1z'
      />
      <path
        className='lats'
        fill={fillColor}
        d='M273.8,110.8c2.2-2.6,4.6-5.4,6.7-8.2c1.1-1.5,2.2-3.2,2.8-4.9c3.8-11.2,7.3-22.5,10.9-33.9
		c0.3-1.1,0.5-2.1,0.9-3.9c-2.9,0.5-5.5,1.1-8,1.4c-5.4,0.8-9.1,4.2-12.5,8.5c-2,2.5-2,5.7-2.2,8.6c2.5,10.9,0.4,21.6-1,32.6
		c-0.1,0.5,0.2,1,0.3,2C272.5,112.2,273.2,111.6,273.8,110.8z'
      />
    </>
  )
}

const TrapsSvg = ({ fillColor }) => {
  return (
    <>
      <path
        className='traps'
        fill={fillColor}
        d='M101.2,29c0.8,4.4,5.9,8.5,11.9,6.4C109.1,33.1,105.3,31.1,101.2,29z'
      />
      <path
        className='traps'
        fill={fillColor}
        d='M69.7,35.5c6.4,2,11.6-2.7,11.9-6.4C77.5,31.1,73.7,33.3,69.7,35.5z'
      />
      <path
        className='traps'
        fill={fillColor}
        d='M101.4,36.1c-0.7-1.8-1.1-3-1.7-4.6c-0.8,1.7-1.4,3.2-2.3,5.3C99,36.5,100.1,36.2,101.4,36.1z'
      />
      <path
        className='traps'
        fill={fillColor}
        d='M85.8,36.9c-1-2.1-1.8-3.5-2.7-5.3c-0.6,1.7-1,2.9-1.5,4.5C82.7,36.2,83.9,36.5,85.8,36.9z'
      />
      <path
        className='traps'
        fill={fillColor}
        d='M233.7,37.9c0,0.3-0.1,0.7-0.1,1c7,0,10.7,5.5,13.3,13.5c3,9.5,6.6,18.5,12.3,25.3c0.8,1,1.8,1.9,3.1,3.2
	c0.3-1.7,0.6-2.6,0.6-3.6c-0.1-9.2-0.3-18.2-0.6-27.4c-0.1-4.5-1.8-7.7-5.1-8.9c-5.4-1.9-10.7-3.9-16.1-5.4
	C239,36,236.3,37.4,233.7,37.9L233.7,37.9z'
      />
      <path
        className='traps'
        fill={fillColor}
        d='M293.8,38.4c-0.7-0.6-1.2-0.9-1.5-1c-8.2-3.2-15.7,0.7-23.1,4.4c-2.7,1.3-4,4.1-4.1,8
	c-0.2,9.2-0.4,18.2-0.5,27.4c0,1,0.2,2,0.4,3.8c1.1-1,1.9-1.5,2.4-2.3c2.6-4.1,5.6-8.2,7.8-12.8c2.5-5.5,4.7-11.5,6.7-17.7
	c1.7-4.8,4.3-7.9,8-8.9C291,39.1,292.1,39,293.8,38.4z'
      />
      <path
        className='traps'
        fill={fillColor}
        d='M266.7,14c-0.4,0-0.8-0.1-1.2-0.1c-0.3,0.9-1,1.9-0.9,2.8c0.6,6.3,1.3,12.6,2,18.9c0.3,2.9,0.7,3.4,4,2.4
	c4.2-1.1,8.2-2.2,12.1-3.4c-2.3-1.6-5.1-3.5-7.8-5.3C269.2,25.5,264.9,21.1,266.7,14z'
      />
      <path
        className='traps'
        fill={fillColor}
        d='M244.8,34.8c3.7,1,7.5,2.1,11.5,3.1c3.5,1,4,0.7,4.3-2.4c0-0.6,0.2-1.3,0.3-1.9c1.3-5.7,2.3-11.5,1.8-17.4
	c-0.1-0.9-0.8-1.7-1.1-2.6c-0.3,0.1-0.5,0.2-0.8,0.3c0.1,0.8,0.3,1.6,0.4,2.5c0.2,4.2-1.6,7.6-5.2,10.4
	C252,29.5,248.2,32.2,244.8,34.8L244.8,34.8z'
      />
    </>
  )
}

const ShouldersSvg = ({ fillColor }) => {
  return (
    <>
      <path
        className='shoulders'
        fill={fillColor}
        d='M53.4,58.4c7.5-0.2,13.7-7.6,17.1-18.7c-2-0.7-3.8-0.5-5.4,0.9C59.3,45.2,55.8,51.4,53.4,58.4z'
      />
      <path
        className='shoulders'
        fill={fillColor}
        d='M112.8,38.9c2.8,11.4,9.3,19.6,16.7,19.5c-2.4-6.9-5.8-13.1-11.6-17.5C116.5,39.7,114.5,39.6,112.8,38.9
		L112.8,38.9z'
      />
      <path
        className='shoulders'
        fill={fillColor}
        d='M50.8,58.9C54.2,52,57.2,44.8,63.9,40c-4.7-1.5-9.1,0.5-11.1,5C50.9,49.3,50.4,53.9,50.8,58.9z'
      />
      <path
        className='shoulders'
        fill={fillColor}
        d='M131.9,58.9c0.3-5.7,0.2-11.5-3.4-16.4c-2.1-2.7-6.2-3.8-9.4-2.3C125.5,44.7,128.6,51.8,131.9,58.9L131.9,58.9
		z'
      />
      <path
        className='shoulders'
        fill={fillColor}
        d='M239.2,42c-3.9-2.6-8.6-2.9-11.5-0.8c-4.8,3.7-6.8,13.4-3.5,18.5C229.3,53.8,234.2,47.8,239.2,42z'
      />
      <path
        className='shoulders'
        fill={fillColor}
        d='M288.1,42c5.1,6,10,11.9,15,17.7c0.3-0.1,0.7-0.2,1-0.3c0.1-2.9,0.7-6,0.3-8.9C303.3,40.7,295.8,37.1,288.1,42
		z'
      />
    </>
  )
}

const InfraspinatusSvg = () => {
  return (
    <>
      <path
        className='infraspinatus'
        d='M248,60.2c-2-4.9-3.7-8.8-5.5-12.9c-0.8-1.7-2.3-2.5-3.9-1.1c-3.3,2.9-5.7,6.5-6.5,11.1
		C237.4,58.3,242.3,59.2,248,60.2z'
      />
      <path
        className='infraspinatus'
        d='M279.3,60.2c5.7-1,10.6-1.9,15.7-2.9c-0.6-4.3-2.8-7.3-5.4-10.1c-2.1-2.3-3.9-2.1-5.2,0.7
		C282.7,51.6,281.3,55.4,279.3,60.2z'
      />
    </>
  )
}

const GlutesSvg = ({ fillColor }) => {
  return (
    <>
      <path
        className='glutes'
        fill={fillColor}
        d='M256,145.4c0.9-0.3,7.9-5.5,6.9-9.4c-1-4.9-4.6-20.6-10.6-18.2c-0.1,0-0.1,0.1-0.3,0.1
		c-11.6,4.7-17,15.4-13.6,27.4C239.3,148.1,250.5,147.6,256,145.4z'
      />
      <path
        className='glutes'
        fill={fillColor}
        d='M288.8,145.3c3.6-12-2.1-22.7-14.3-27.4c-0.1,0-0.1-0.1-0.3-0.1c-6.3-2.4-10,13.2-11.1,18.2
		c-1.1,4,6.3,9.1,7.2,9.4C276,147.6,287.8,148.1,288.8,145.3z'
      />
      <path
        className='glutes'
        fill={fillColor}
        d='M289.7,127.2c-1-4.5-1.7-9-2.9-13.5c-0.8-3.1-2.6-4.2-5.5-4.1c-2.8,0.1-5.3,1.9-6.1,4.6
		C285.8,120.3,285.8,120.3,289.7,127.2z'
      />
      <path
        className='glutes'
        fill={fillColor}
        d='M237.8,126.7c0.2,0.1,0.5,0.2,0.7,0.3c1.7-7.4,7.6-10.4,13.9-12.8c-1.8-3.4-4.5-5-7.5-4.7
		c-3.1,0.3-4.3,2.7-4.9,5.4C239.2,118.8,238.5,122.9,237.8,126.7z'
      />
    </>
  )
}

const AdductorsSvg = ({ fillColor }) => {
  return (
    <>
      <path
        className='adductors'
        fill={fillColor}
        d='M88.6,170.7c-3-16.9-10.6-32.3-17-48.6c-0.6,5.1,0.3,9.5,2,13.7C78.5,147.6,83.6,159.2,88.6,170.7L88.6,170.7
		z'
      />
      <path
        className='adductors'
        fill={fillColor}
        d='M94.8,170.3c1.2-3.1,2.3-6.3,3.7-9.4c3.5-8.2,7.2-16.3,10.6-24.5c2.2-5.4,2.8-10.2,2.1-13.8
		C104.9,138.4,97.4,153.5,94.8,170.3L94.8,170.3z'
      />
      <path
        className='adductors'
        fill={fillColor}
        d='M95.8,158c0.9-3,1.9-6.1,2.7-9.1c0.3-1,0.1-2.3-0.3-3.3c-1.5-3-3.2-6-4.8-8.9C92,141.1,93.3,153.8,95.8,158
		L95.8,158z'
      />
      <path
        className='adductors'
        fill={fillColor}
        d='M87.2,158.8c2.6-7.7,3.1-15,2.3-22.4c-1.5,2.8-3,5.6-4.5,8.4c-0.5,1-1.2,2.2-1,3.1
		C84.9,151.3,86,154.7,87.2,158.8z'
      />
      <path
        className='adductors'
        fill={fillColor}
        d='M81.8,130.7c-3.5,5.2-2.2,9.6,1.5,13.9C89.1,135.7,88.9,134.7,81.8,130.7z'
      />
      <path
        className='adductors'
        fill={fillColor}
        d='M100.8,130.3c-1.7,1.5-3.4,3-5.1,4.7c-0.3,0.3-0.5,1.2-0.4,1.6c1.1,2.7,2.4,5.5,3.9,8.5
		C103.1,140.1,104.7,135.7,100.8,130.3z'
      />
      <path
        className='adductors'
        fill={fillColor}
        d='M105,127.3c-3,1.8-3.1,4.1-0.2,6.4C106.1,131.5,107,129.5,105,127.3z'
      />
      <path
        className='adductors'
        fill={fillColor}
        d='M77.7,127.3c-1.6,2.3-1,4.4,0.6,6.5C80.9,130.9,80.6,128.8,77.7,127.3z'
      />
      <path
        className='adductors'
        fill={fillColor}
        d='M260,146.8c-3.7,0.3-4.2,0.9-4.2,4c0.1,3.3-0.2,6.6,0,9.9c0.3,5.9,0.8,11.7,1.2,17.5h0.8
		C259.9,167.7,259.9,157.3,260,146.8z'
      />
      <path
        className='adductors'
        fill={fillColor}
        d='M269.9,178.1c0.2-1.4,0.4-2.5,0.6-3.8c0.4-3.9,1-7.6,1.1-11.5c0.1-4.2-0.4-8.4-0.2-12.6
		c0.2-2.9-1.1-3.8-3.7-4C266.7,152.1,268.1,173.6,269.9,178.1L269.9,178.1z'
      />
    </>
  )
}

const HamstringsSvg = ({ fillColor }) => {
  return (
    <>
      <path
        className='hamstrings'
        fill={fillColor}
        d='M271.8,208.1c0.3,0,0.7,0,1,0.1c0.8-2.1,1.7-4.3,2.4-6.4c1.7-4.8,3.8-9.5,5-14.4c2.9-11.6,1.1-23.1-0.3-34.6
		c-0.4-3.1-2.5-4.9-6-5.2c-1.3,8.3,0.5,16.5,1.2,24.7c0.6,6.8,0.7,13.7,0.2,20.5c-0.3,3.7-2.3,7.1-3.3,10.6
		C271.7,205.1,271.9,206.6,271.8,208.1L271.8,208.1z'
      />
      <path
        className='hamstrings'
        fill={fillColor}
        d='M253.3,147.5c-4.1,0.6-5.9,2.3-6.2,6.1c-0.5,5.2-1.3,10.3-1.4,15.5c-0.1,5.4-0.3,10.8,0.9,16
		c1.9,7.9,5,15.5,7.6,23.6c2.6-2.3,1.4-4.6,0.5-6.4c-4.8-10.1-4.2-20.7-2.5-31.3C253.4,163.1,254,155.5,253.3,147.5L253.3,147.5z'
      />
      <path
        className='hamstrings'
        fill={fillColor}
        d='M285.9,204.8h0.4c0.1-2.4,0.3-5,0.4-7.4c0.2-3.3-0.1-6.9,0.8-10c2.5-8.6,2.1-17,0.4-25.7
		c-0.8-4.1-2.1-7.7-5.9-9.4c0.5,5.4,1.4,11.1,1.5,16.7c0.1,6.2-1.1,12.5-0.7,18.7C283.1,193.4,284.8,199.1,285.9,204.8L285.9,204.8z
		'
      />
      <path
        className='hamstrings'
        fill={fillColor}
        d='M241.1,205.2c1-4.6,1.9-8.6,2.6-12.7c0.4-2.5,0.5-5.1,0.4-7.6c-0.1-5-0.7-9.9-0.5-14.9
		c0.2-5.9,1-11.7,1.6-18.4c-1.8,2-4,3.4-4.5,5.4c-2.3,8.6-4.3,17.3-1.8,26.4c1.4,5.1,2.1,10.2,1.7,15.6
		C240.5,200.9,240.9,203,241.1,205.2L241.1,205.2z'
      />
      <path
        className='hamstrings'
        fill={fillColor}
        d='M270.8,201.6c3.9-7.1,4.3-14.8,1.7-31.4C270.3,177.4,269.2,197.6,270.8,201.6z'
      />
      <path
        className='hamstrings'
        fill={fillColor}
        d='M256.5,202.1c1.5-6,0.3-25.6-1.8-31.2c-0.4,3.8-0.6,7.5-1.1,11.2C252.6,189,253.1,195.6,256.5,202.1z'
      />
    </>
  )
}

const CalvesSvg = ({ fillColor }) => {
  return (
    <>
      <path
        className='calves'
        fill={fillColor}
        d='M96.6,271.9c0.3,0.2,0.6,0.4,0.8,0.6c0.4-0.8,1-1.6,1.2-2.4c2.7-11.7,5.6-23.2,8.1-34.9
		c1.4-6.5,2.6-13.1,3.7-19.7c0.2-1.3-0.7-4-1.6-4.3c-2.2-0.6-2.6,1.8-3.4,3.3c-0.5,0.9-0.8,2-1,3c-0.8,5.3-1.8,10.5-2.3,15.8
		c-0.7,8-0.8,16-1.8,24C99.7,262.5,97.8,267.3,96.6,271.9L96.6,271.9z'
      />
      <path
        className='calves'
        fill={fillColor}
        d='M85.6,272.4c0.3-0.2,0.5-0.4,0.8-0.7c-2.9-9.2-5.3-18.5-5.4-28.2c-0.1-6.3-0.4-12.5-1.1-18.7
		c-0.5-4-1.8-7.8-3.1-11.6c-0.3-1-1.8-1.5-2.8-2.3c-0.5,1-1.3,2-1.4,3.1c-0.1,2.1-0.1,4.4,0.3,6.4c1.6,7.5,3.3,14.9,5.1,22.4
		c2.1,9.2,4.3,18.4,6.4,27.6C84.5,271.3,85.1,271.9,85.6,272.4L85.6,272.4z'
      />
      <path
        className='calves'
        fill={fillColor}
        d='M71.3,225.3c-0.3,0-0.5,0-0.8,0c0.2,3.1,0,6.5,0.7,9.5c2.6,11.4,5.7,22.6,8.5,33.9c0.3,1.4,0.7,2.7,1.1,4.7
		C82,271.2,73,227.8,71.3,225.3L71.3,225.3z'
      />
      <path
        className='calves'
        fill={fillColor}
        d='M111.9,225.3c-0.2,0-0.4,0-0.6-0.1c-0.3,0.5-0.6,1-0.7,1.6c-3.2,15-6.4,30-9.5,45c-0.1,0.3,0.5,0.8,1,1.5
		c1-4.6,1.9-8.6,2.9-12.6c2.3-9,4.8-18,6.9-27.2C112.5,231.1,111.9,228.2,111.9,225.3L111.9,225.3z'
      />
      <path
        className='calves'
        fill={fillColor}
        d='M96.4,217.7c-1.5,6.9-2.8,13.7-0.8,20.7C98.9,231.6,97.7,224.7,96.4,217.7z'
      />
      <path
        className='calves'
        fill={fillColor}
        d='M87.3,238.4c2.2-7,0.5-13.7-0.9-20.5C85.4,224.8,83.8,231.7,87.3,238.4z'
      />
      <path
        className='calves'
        fill={fillColor}
        d='M99,237.8c-0.4-0.1-0.8-0.1-1.2-0.2c-3.9,8.5,0.8,17.4-1.3,26.1c0.3,0,0.7,0,1,0.1
		C98,255,98.5,246.4,99,237.8L99,237.8z'
      />
      <path
        className='calves'
        fill={fillColor}
        d='M85.1,261.8h0.6c0.2-4.1,0.5-8.1,0.7-12.3c0.4-8,0.2-9.5-2.3-11.8C84.4,245.9,84.8,253.9,85.1,261.8z'
      />
      <path
        className='calves'
        fill={fillColor}
        d='M256.4,245.3c5.2-6.1-1.5-42.6-7.7-45.1c0,5.2-0.1,10.5,0,15.8c0.2,6.3,0.7,12.5,1,18.8
		C250,239.7,252.8,242.7,256.4,245.3z'
      />
      <path
        className='calves'
        fill={fillColor}
        d='M279.3,199.7c-0.3-0.1-0.5-0.2-0.8-0.3c-0.7,1.3-1.7,2.6-2.2,4.1c-1.1,2.9-1.9,6-2.9,8.8
		c-2.7,7.4-4.4,15.1-4.8,23c-0.2,3.4-0.1,7.1,2.4,10.2c3.2-2.8,6.4-5.3,6.6-9.9c0.3-8.6,0.9-17.3,1.3-26
		C279,206.3,279.1,203.1,279.3,199.7L279.3,199.7z'
      />
      <path
        className='calves'
        fill={fillColor}
        d='M283.2,197c-2.4,0.8-2.7,2.5-2.7,4.2c-0.1,4.9-0.3,9.6-0.1,14.5c0.2,6.9,0.4,13.8-1.5,20.5
		c-0.9,3.2-0.2,5.3,2.7,6.8c0.2-0.1,0.4-0.2,0.6-0.4c0.3-0.2,0.5-0.5,0.7-0.8c2.9-5.7,5.1-11.7,4.2-18.3c-1-7.2-2.1-14.3-3.1-21.4
		C283.6,200.4,283.5,198.7,283.2,197L283.2,197z'
      />
      <path
        className='calves'
        fill={fillColor}
        d='M245.5,243.1c3.9-2.7,3.4-2.7,2.9-6.7c-0.8-6.2-1.2-12.4-1.5-18.6c-0.3-5.9-0.2-11.8-0.4-17.6
		c0-1.1-1.1-2.1-1.6-3.2c-0.3,0.1-0.6,0.2-0.9,0.4c-0.5,3.9-1,7.7-1.5,11.6c-0.8,6.3-1.9,12.5-2.2,18.8
		C240,233.4,242.3,238.4,245.5,243.1z'
      />
      <path
        className='calves'
        fill={fillColor}
        d='M252.3,286.7h0.9c0.1-0.9,0.2-1.9,0.3-2.8c0.7-8.2,1.2-16.3,2-24.5c0.5-5.6,1.8-11.4-3.1-15.7
		c-0.9-0.8-2.7-1.6-3.5-1.3c-1.5,0.7-3.3,1.8-2.6,4.4c0.8,2.8,1.5,5.7,1.9,8.6c1.3,9.7,2.5,19.5,3.8,29.2
		C252,285.2,252.2,285.9,252.3,286.7L252.3,286.7z'
      />
      <path
        className='calves'
        fill={fillColor}
        d='M274.2,286.6h0.9c0.1-0.8,0.3-1.5,0.4-2.3c0.9-8,1.6-15.9,2.7-23.9c0.6-4.8,1.8-9.4,2.8-14.1
		c0.5-2.3-1.2-3.4-2.6-4.2c-0.7-0.4-2.4,0.5-3.3,1.2c-4.2,3.5-4.1,8.3-3.7,13.3c0.9,9.1,1.5,18.3,2.3,27.4
		C273.9,284.9,274.1,285.8,274.2,286.6L274.2,286.6z'
      />
      <path
        className='calves'
        fill={fillColor}
        d='M277.5,286.2c0.3,0.1,0.7,0.2,1,0.3c0.2-0.8,0.6-1.6,0.7-2.4c0.1-1.4-0.2-2.8,0-4.3c0.5-3.9,1.5-7.7,1.8-11.6
		c0.3-3.7,0.1-7.3,0.1-11c-0.4,0-0.9,0-1.3,0C279.2,266.9,278.3,276.6,277.5,286.2L277.5,286.2z'
      />
      <path
        className='calves'
        fill={fillColor}
        d='M249,286.7c0-5.4,0.3-10.2-0.1-15.1c-0.4-4.8-1.4-9.4-2.1-14.1c-0.3,0-0.5,0.1-0.8,0.1c0,3.3-0.2,6.6,0.1,9.9
		s0.6,6.8,1.7,10C248.7,280.3,246.6,283.9,249,286.7L249,286.7z'
      />
    </>
  )
}

const ChestSvg = ({ fillColor }) => {
  return (
    <>
      <path
        className='chest'
        fill={fillColor}
        d='M120,57.4c-2.3-1.6-4.4-2.9-6.3-4.4c-1.9-1.4-3.8-3-5.8-4.3c-3-1.9-6.1-3.8-9.2-5.3c-1.2-0.6-3.2-0.8-4.2-0.1
		c-0.9,0.7-1.2,2.6-1.2,4.1c0,3.9,0.3,7.7,0.5,11.6c0,0.3-0.2,0.7-0.3,1c-0.9,3.4-0.1,5.1,3.5,5.7C106.1,67,112.9,62.3,120,57.4z'
      />
      <path
        className='chest'
        fill={fillColor}
        d='M63.1,57.3c5.1,4.4,10.4,7.1,16.6,8.3c2,0.4,4.3,0.3,6.3,0c3.4-0.6,4.4-2.1,3.5-5.5c-0.1-0.6-0.3-1.2-0.3-1.8
		c0.1-4.3,0.4-8.5,0.4-12.7c0-2.3-1.8-3.4-4.1-2.6c-2,0.8-4.1,1.6-5.8,2.7C74.2,49.3,68.8,53.2,63.1,57.3L63.1,57.3z'
      />
      <path
        className='chest'
        fill={fillColor}
        d='M118.1,54.3c-1.9-3.2-3.7-6.2-5.3-9.2s-4.2-4.9-7.4-5.8c-2.9-0.8-6.5-0.2-8.4,1.6
		C105.7,43.2,111.2,49.4,118.1,54.3L118.1,54.3z'
      />
      <path
        className='chest'
        fill={fillColor}
        d='M64.8,54.3c6.9-5.1,12.7-11.4,21.3-13.5C81.8,37.5,73,39,69.9,45.4C68.3,48.3,66.6,51.2,64.8,54.3z'
      />
    </>
  )
}

const ObliquesSvg = ({ fillColor }) => {
  return (
    <>
      <path
        className='obliques'
        fill={fillColor}
        d='M77.5,118.3c-0.6-7.4-1-14-1.9-20.5c-0.3-1.7-2.2-3.5-3.8-4.8c-1.9-1.5-3-0.8-3.1,1.7c-0.2,4.1,0,8.1-0.8,12
		c-1.2,6.2,2.9,9.9,7.8,12.2C76.1,119,77.2,118.3,77.5,118.3L77.5,118.3z'
      />
      <path
        className='obliques'
        fill={fillColor}
        d='M114.3,106.9c0-4.1,0.1-8.2,0-12.3c0-2.1-1-2.8-2.9-1.9c-2.3,1.1-4.2,2.9-4.5,5.7c-0.7,6.2-1.1,12.5-1.7,18.7
		c-0.2,2.1,0.8,2.6,2.5,1.7C113.3,115.5,115.9,112.7,114.3,106.9L114.3,106.9z'
      />
      <path
        className='obliques'
        fill={fillColor}
        d='M117.4,75.6c-2.4,3.2-5,6.2-7.1,9.4c-1.1,1.7-1.4,4-0.2,6C114.6,88.8,117.4,82.7,117.4,75.6z'
      />
      <path
        className='obliques'
        fill={fillColor}
        d='M65.4,75.6c0.4,6.4,1.7,11.9,7.2,15.8c1.4-2.5,0.9-4.8-0.5-6.7C70.1,81.7,67.8,78.8,65.4,75.6z'
      />
      <path
        className='obliques'
        fill={fillColor}
        d='M68,74.2c-0.1,2.9,2.6,6.7,5.7,7.8C74.7,77.8,73,75.4,68,74.2z'
      />
      <path
        className='obliques'
        fill={fillColor}
        d='M109.6,83.1c2.2-3,4.2-5.7,6.4-8.7C110.4,74.6,107.6,78.7,109.6,83.1z'
      />
      <path
        className='obliques'
        fill={fillColor}
        d='M108.7,75.1c0.3,0.1,0.6,0.3,0.9,0.4c1.4-2.7,2.8-5.6,4.4-8.3c-0.2-0.1-0.5-0.2-0.7-0.4
		C107.8,70.6,107.5,71.1,108.7,75.1L108.7,75.1z'
      />
      <path
        className='obliques'
        fill={fillColor}
        d='M69.1,66.4c0.8,3.8,2,6.7,4.8,9C75.4,71.5,74.9,70.6,69.1,66.4z'
      />
      <path
        className='obliques'
        fill={fillColor}
        d='M69.8,72.5c-1.2-2-2.2-3.7-3.4-5.7C64.9,70.9,65.7,72.2,69.8,72.5z'
      />
      <path
        className='obliques'
        fill={fillColor}
        d='M113.2,72.5c4.1-0.1,4.9-1.7,3.1-5.6C115.2,68.8,114.3,70.5,113.2,72.5z'
      />
      <path
        className='obliques'
        fill={fillColor}
        d='M246.4,107.4c-1.5-4.7-3-9.2-4.6-13.7c-0.1,0.1-0.2,0.1-0.3,0.2c-0.2,5-0.5,10-0.7,15.2
		C242.7,108.4,244.3,108,246.4,107.4z'
      />
      <path
        className='obliques'
        fill={fillColor}
        d='M286.7,108.9c-0.4-5.1-0.7-9.6-1-14.2c-0.2,0-0.4,0-0.6-0.1c-1.3,4.3-2.6,8.5-4,12.9
		C283.3,108.1,284.8,108.5,286.7,108.9z'
      />
    </>
  )
}

const QuadricepsSvg = ({ fillColor }) => {
  return (
    <>
      <path
        className='quads'
        fill={fillColor}
        d='M71.3,185.9c-0.8-5.4-1.7-10.7-2.3-16.1c-1.1-9.8-1.5-19.6-0.5-29.5c0.6-6.5,1.2-13,1.7-19.5
		c0.1-1-0.5-2.1-0.7-3.2c-0.3,0.1-0.6,0.1-0.9,0.2C62.9,140.8,64.3,163.4,71.3,185.9z'
      />
      <path
        className='quads'
        fill={fillColor}
        d='M111.5,186.8c7.1-22.8,8.4-45.8,2.4-69.2c-0.6,0.6-1.1,1.3-1.1,2c0,1.7,0.1,3.3,0.2,5.1
		c0.6,7.7,1.5,15.3,1.8,23C115.4,160.9,114,174,111.5,186.8L111.5,186.8z'
      />
      <path
        className='quads'
        fill={fillColor}
        d='M80.2,195.4c0.4-8.8,0.7-17.4,1.1-26.1c0.2-4.1,1.7-8.1,0-12.2c-3.3-7.7-6.8-15.4-10.3-23.5
		c-1.3,8.5-2.5,16.5-0.5,24.8c2.2,9.1,3.9,18.3,5.8,27.5c0.6,3.1,1,6.4,1.5,9.4h2.4V195.4z'
      />
      <path
        className='quads'
        fill={fillColor}
        d='M104.6,195.4c2-10.3,3.7-20.7,6.1-30.7c1.6-6.9,3.2-13.7,2.4-20.9c-0.4-3.3-0.9-6.7-1.3-10
		c-0.9,1.2-1.2,2.3-1.7,3.3c-2.6,6.1-5.4,12.1-7.9,18.2c-1.3,3.1-1.7,6.3-1.4,9.8c0.8,8.1,1.2,16.2,1.6,24.3c0.1,2-0.3,4-0.4,6.1
		C103.2,195.4,104,195.4,104.6,195.4L104.6,195.4z'
      />
      <path
        className='quads'
        fill={fillColor}
        d='M84,164.8c-0.3,3.4-0.8,7-1,10.4c-0.3,6.2-0.4,12.5-0.4,18.7c0,1.8,0.1,4.3,2.6,4.3c2.5,0.1,2.8-2.4,3.2-4.3
		C90.2,183.7,87.9,174.1,84,164.8L84,164.8z'
      />
      <path
        className='quads'
        fill={fillColor}
        d='M99.4,164.5c-0.3,0-0.6,0-1,0c-3.3,9-5.5,18.4-4.1,28.1c0.2,1.5,0.7,3.1,1.5,4.5c1.1,1.8,3,1.5,4-0.4
		c0.3-0.7,0.6-1.5,0.6-2.3C100.1,184.4,99.7,174.5,99.4,164.5L99.4,164.5z'
      />
      <path
        className='quads'
        fill={fillColor}
        d='M113.1,162.1c-3.4,10.7-5.2,22-6.6,33.2c-0.1,0.6,0.6,1.3,1.1,2.5C111.5,185.7,112.2,174,113.1,162.1z'
      />
      <path
        className='quads'
        fill={fillColor}
        d='M75.6,196.9c0-11.8-2.5-23.1-5.7-34.4C70.6,174.1,71.4,185.7,75.6,196.9z'
      />
      <path
        className='quads'
        fill={fillColor}
        d='M236.3,163.7c2.8-5.9,3.8-11.7,0-18.2V163.7z'
      />
      <path
        className='quads'
        fill={fillColor}
        d='M289.9,164.5h0.9c0-6.1,0-12.1,0-18.2c-1.2,1.9-2.3,4.1-2.2,6.1C288.7,156.5,289.5,160.6,289.9,164.5
		L289.9,164.5z'
      />
    </>
  )
}

const TricepsSvg = ({ fillColor }) => {
  return (
    <>
      <path
        className='triceps'
        fill={fillColor}
        d='M296.9,55.4c-0.4,4.3-0.8,8.1-1.1,12.1c-0.2,3.1-0.6,6.4-0.3,9.5c0.5,4.7,2.7,8.6,5.5,11.8
		c0.4-5.9,0.5-12,1.1-17.9C302.9,65,300.6,60.2,296.9,55.4z'
      />
      <path
        className='triceps'
        fill={fillColor}
        d='M225.6,89.2c3.8-3.7,6.3-8.1,6.3-13.4c-0.1-6.7-0.9-13.4-1.4-20.2c-4.4,4.8-6.1,10.2-5.2,16.7
		C226,78,226.9,83.5,225.6,89.2L225.6,89.2z'
      />
      <path
        className='triceps'
        fill={fillColor}
        d='M219.1,84.1c1.5-7.2,3-14.3,4.8-22.2C219.4,69.1,218.9,76.6,219.1,84.1z'
      />
      <path
        className='triceps'
        fill={fillColor}
        d='M303.4,61.9c1.6,7.8,3.3,15.4,5,23C308.6,77,308,69,303.4,61.9z'
      />
      <path
        className='triceps'
        fill={fillColor}
        d='M304.3,71.6c-0.3,0-0.5,0-0.8,0c0,4.2-0.1,8.3,0.1,12.5c0,0.6,0.8,1.2,1.2,1.9c0.5-0.7,1.4-1.4,1.3-2
		C305.5,79.7,304.9,75.6,304.3,71.6L304.3,71.6z'
      />
      <path
        className='triceps'
        fill={fillColor}
        d='M224,71.6c-0.3,0-0.7,0-1,0c-0.6,4.1-1.2,8.2-1.6,12.3c-0.1,0.7,0.9,1.4,1.4,2.1c0.4-0.7,1-1.3,1.1-2
		c0.2-2,0.1-4.1,0.1-6.2S224,73.6,224,71.6z'
      />
    </>
  )
}

const LowerBackSvg = ({ fillColor }) => {
  return (
    <>
      <path
        className='lowerBack'
        fill={fillColor}
        d='M263.2,118.5c1.4,0.4,7-8.7,7.1-8.6c0,0,0,0.1,0.1,0.1c0,0,0,0,0.1,0s2.7-33.3,0.5-33.6
		C268.4,76.1,260.4,117.6,263.2,118.5z'
      />
      <path
        className='lowerBack'
        fill={fillColor}
        d='M263.4,118.5c-1.4,0.4-6.9-8.7-7.1-8.6c0,0,0,0.1-0.1,0.1c0,0,0,0-0.1,0s-2.7-33.3-0.5-33.6
		C258.1,76.1,266.2,117.6,263.4,118.5z'
      />
    </>
  )
}

function MusclesAnatomy (props) {
  const getFillColor = (muscle) => {
    const {
      musclesUsageMap,
      muscleToColor,
      rgb
    } = props
    const muscleUsage = musclesUsageMap[muscle]
    if (!muscleUsage || muscleUsage < MIN_USAGE) {
      return '#000000'
    }

    if (muscleToColor) {
      return muscleToColor[muscle] || '#191919'
    }
    const opacity = MIN_OPACITY +
      (
        OPACITY_RATIO_PER_UNIT * muscleUsage
      )
    return `rgba(${rgb.join(',')}, ${opacity})`
  }

  return (
    <View
      w
    >
      <svg
        viewBox='0 0 357 301'
        height={props.height}
        fill='#000000'
      >
        <NeckSvg fillColor={getFillColor(MUSCLE.NECK)} />
        <TrapsSvg fillColor={getFillColor(MUSCLE.TRAPS)} />
        <ShouldersSvg fillColor={getFillColor(MUSCLE.SHOULDERS)} />
        <ChestSvg fillColor={getFillColor(MUSCLE.CHEST)} />
        <InfraspinatusSvg />
        <TricepsSvg fillColor={getFillColor(MUSCLE.TRICEPS)} />
        <BicepsSvg fillColor={getFillColor(MUSCLE.BICEPS)} />
        <ForearmsSvg fillColor={getFillColor(MUSCLE.FOREARMS)} />
        <LatsSvg fillColor={getFillColor(MUSCLE.LATS)} />
        <LowerBackSvg fillColor={getFillColor(MUSCLE.LOWER_BACK)} />
        <AbsSvg fillColor={getFillColor(MUSCLE.ABS)} />
        <ObliquesSvg fillColor={getFillColor(MUSCLE.OBLIQUES)} />
        <AbductorsSvg
          fillColor={getFillColor(MUSCLE.ABDUCTORS) ||
            getFillColor(MUSCLE.HIP_FLEXORS)}
        />
        <QuadricepsSvg fillColor={getFillColor(MUSCLE.QUADRICEPS)} />
        <GlutesSvg fillColor={getFillColor(MUSCLE.GLUTES)} />
        <HamstringsSvg fillColor={getFillColor(MUSCLE.HAMSTRINGS)} />
        <AdductorsSvg fillColor={getFillColor(MUSCLE.ADDUCTORS)} />
        <CalvesSvg fillColor={getFillColor(MUSCLE.CALVES)} />
        <OthersSvg />
      </svg>
    </View>
  )
}

MusclesAnatomy.propTypes = {
  height: PropTypes.number,
  musclesUsageMap: PropTypes.object.isRequired,
  rgb: PropTypes.arrayOf(PropTypes.number)
}

MusclesAnatomy.defaultProps = {
  height: 200,
  rgb: [
    230,
    57,
    70
  ]
}

export default MusclesAnatomy
export const MUSCLE_TO_SVG = {
  [MUSCLE.NECK]: NeckSvg,
  [MUSCLE.TRAPS]: TrapsSvg,
  [MUSCLE.SHOULDERS]: ShouldersSvg,
  [MUSCLE.CHEST]: ChestSvg,
  [MUSCLE.TRICEPS]: TricepsSvg,
  [MUSCLE.BICEPS]: BicepsSvg,
  [MUSCLE.FOREARMS]: ForearmsSvg,
  [MUSCLE.LATS]: LatsSvg,
  [MUSCLE.LOWER_BACK]: LowerBackSvg,
  [MUSCLE.ABS]: AbsSvg,
  [MUSCLE.OBLIQUES]: ObliquesSvg,
  [MUSCLE.ABDUCTORS]: AbductorsSvg,
  [MUSCLE.HIP_FLEXORS]: AbductorsSvg,
  [MUSCLE.QUADRICEPS]: QuadricepsSvg,
  [MUSCLE.GLUTES]: GlutesSvg,
  [MUSCLE.HAMSTRINGS]: HamstringsSvg,
  [MUSCLE.ADDUCTORS]: AdductorsSvg,
  [MUSCLE.CALVES]: CalvesSvg
}

export const MUSCLE_GROUPS_TO_MUSCLES = {
  [MUSCLE.UPPER_BACK]: [
    MUSCLE.TRAPS,
    MUSCLE.LATS,
    MUSCLE.NECK
  ],
  [MUSCLE.MIDDLE_BACK]: [
    MUSCLE.TRAPS,
    MUSCLE.LATS
  ]
}
